import { EventPriceDto, EventPriceTypesEnum } from '@sweatpals/shared';

export const parsePreselectedTierQty = (price: EventPriceDto, preselectedTierQty?: string | number) => {
	const parsedPreselectedTierQty = Number(preselectedTierQty) || 1;
	const minTicketsPerOrder = price.minTicketsPerOrder ?? 1;
	const quantity = Math.max(parsedPreselectedTierQty, minTicketsPerOrder);

	if (price.tierTypeId !== EventPriceTypesEnum.Group) {
		return quantity;
	}

	const ticketsPerGroup = price.ticketsPerGroup ?? 1;

	return Math.ceil(quantity / ticketsPerGroup) * ticketsPerGroup;
};
